import { Component, OnInit } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UserService } from '../../../../../../../shared/services/user.service';
import { DocumentService } from '../../../../../../../shared/services/document-service';
import { DeleteUserByFirm, Details, UserClientVm, UserDetails } from '../../../../../../../store/user/user.interface';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';
import { Reviewer } from '../../../people.interface';
import { ConfirmationDialogService } from '../../../../../../../shared/services/confirmation-dialog.service';
import { ToastService } from '../../../../../../../shared/services/toast.service';
import { RequestInformationComponent } from '../request-information/request-information.component';
import { TooltipModule } from 'primeng/tooltip';
import { ManualApprovalComponent } from '../manual-approval/manual-approval.component';
import { constants } from '../../../../../../../shared/constants/constants';
import { ConfigurationService } from '../../../../../../../shared/services/configuration.service';
import { ManualCredentialEducationApprovalComponent } from '../manual-approval-creds-education/manual-approval-creds-education.component';
import { DeleteUserConfirmation } from '../../../all/modals/delete/delete-user-confirmation.component';
import { HelperService } from '../../../../../../../shared/services/helper.service';

@Component({
    selector: 'app-credentialing',
    imports: [TableModule, ButtonModule, CommonModule, TooltipModule, CheckboxModule],
    standalone: true,
    templateUrl: './credentialing.component.html',
    styleUrl: './credentialing.component.scss'
})
export class CredentialingComponent implements OnInit {
  credentials: UserDetails = [];
  userObject!: UserClientVm;
  approvalRef: DynamicDialogRef | undefined;
  reqInfo: DynamicDialogRef | undefined;  
  expiredCredentialsCandidateView: boolean;
  isFirmCredentialManualApprovalEnabled: boolean = false;
  constants = constants;
  isPwcEnabled = false;
  selectedCredentials: any[] = [];
  selectAll: boolean = false;

  constructor(private ref: DynamicDialogRef, public config: DynamicDialogConfig, private userService: UserService,
    private documentService: DocumentService, private confirmationDialogService: ConfirmationDialogService,
    private toast: ToastService, public dialogService: DialogService, private configurationService: ConfigurationService,
    public helperService: HelperService
  ) {
    this.expiredCredentialsCandidateView = this.config.data.expiredCredentialsCandidateView;
   }

  ngOnInit(): void {
    this.isPwcEnabled = this.configurationService.getPwcFlag();
    this.userObject = this.userService.getSessionUser();
    this.isFirmCredentialManualApprovalEnabled = this.userObject.firm.firmCredentialManualApproval;
    this.getAbDetails();
    this.selectedCredentials = [];
  }


  ranCriminalCheck(){
    let cred = this.credentials.find((c)=>{return c.type === "CRIMINAL";})
    return (cred && cred.bgStatus);
  }

  hasPendingEducation(): boolean {
    return this.credentials.some((credential: Details) => 
      credential.type === 'EDUCATION' && credential.bgStatus !== constants.secureBackgroundStatus.manualApproved
    );
  }

  hasPendingCredentials(): boolean {
    return this.credentials.some((credential: Details) => 
      credential.type === 'CREDENTIALS' && credential.bgStatus !== constants.secureBackgroundStatus.manualApproved
    );
  }
  getAbDetails() {

    this.config.data.reviewer.tenants = this.config.data.reviewer.tenants.filter((d: any) => {
      return d.firm._id === this.userObject.firm._id;
    })
    this.userService.getAbdetails(this.config.data.reviewer._id).subscribe((resp: UserDetails) => {
      if(this.expiredCredentialsCandidateView){
        resp = resp.filter((c)=>{
            return c.type == constants.bgCheckTypes.CREDENTIALS; 
        })
      }
      resp.map((d: Details) => {
        if (d.auditDocumentId) {
          d.downloadURL = this.documentService.getDocumentPathById(d.auditDocumentId);
        }
        if (d.certificate) {
          d.certificateDownloadURL = this.documentService.getDocumentPathById(d.certificate);
        }
      })

      this.credentials = resp;
    })
  }

  closeDialog() {
    this.ref.close();
  }

  backgroundCheck(type: string, data: Details) {
    this.ref.close({ from: type, data: data });
  }

  downloadDocument(url: any) {
    window.open(url, '_self');
  }


  openBackgroundcheckModal($event: Event, summary: any): void{
    const mesg = `You are about to send background check request for following reviewer <br> <strong>${this.config.data.reviewer.firstName} ${this.config.data.reviewer.lastName}</strong>. Are you sure?`
    this.confirmationDialogService.confirm({
      target: $event.target as EventTarget,
      message: mesg,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      rejectIcon: "none",
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
        const requestObject = { type: 'CRIMINAL', typeId: summary._id || undefined, tenantId: this.userObject.firm._id };
        this.userService.invokeCriminalCheck(this.config.data.reviewer._id, requestObject ).subscribe((response: any) => {
          this.toast.showSuccess('Background Check invoked successfully')
        })
      }
    });
  }

  approveAllCredentialsAndEducation($event: Event, reviewer: Reviewer) {
    this.manualBulkCredsEducationApproval($event);
  }

  manualApproveCredential($event: Event, credential: Details) {

      const data = {
        reviewer:  this.config.data.reviewer,
        credential: credential,
        isBulk: false
      }
      this.approvalRef = this.dialogService.open(ManualApprovalComponent, {
        data: data,
        header: 'Manual Approval',
        width: 'calc(100vw - 100px)',
        contentStyle: { overflow: 'auto' },
        breakpoints: {
          '960px': '75vw',
          '640px': '90vw'
        }
      });
      this.approvalRef.onClose.subscribe((resp: any) => {
        this.ngOnInit();
      
      });
  }

  manualBulkCredsEducationApproval($event: Event, credsOnly = false): void {
    let credentials = this.credentials.filter((credential: any) => credential.type === 'CREDENTIALS' && credential.bgStatus !== constants.secureBackgroundStatus.manualApproved);
    let educationCredentials = this.credentials.filter((credential: any) => credential.type === 'EDUCATION' && credential.bgStatus !== constants.secureBackgroundStatus.manualApproved);
    if(credsOnly){
      credentials = this.selectedCredentials.filter((credential: any) => credential.type === 'CREDENTIALS');
      educationCredentials = this.selectedCredentials.filter((credential: any) => credential.type === 'EDUCATION');
    }
    
    const data = {
        reviewer:  this.config.data.reviewer,
        credentials,
        educationCredentials,
        credsOnly
      }
      this.approvalRef = this.dialogService.open(ManualCredentialEducationApprovalComponent, {
        data: data,
        header: 'Manual Credentials And Educations Approval',
        width: 'calc(100vw - 100px)',
        contentStyle: { overflow: 'auto' },
        breakpoints: {
          '960px': '75vw',
          '640px': '90vw'
        },
        closable: true
      });
      this.approvalRef.onClose.subscribe((resp: any) => {
        this.ngOnInit();
      });
  }
  

  requestInformation($event: Event): void {
    const data = {
      reviewer: this.config.data.reviewer
    }
    this.reqInfo = this.dialogService.open(RequestInformationComponent, {
      data: data,
      header: `Request additional information from ${data.reviewer.firstName}`,
      width: '35vw',
      contentStyle: { overflow: 'auto' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      }
    });
    this.reqInfo.onClose.subscribe((resp: any) => {
    });
  }

  checkToShowNscDetails(credential: any){
    return (credential.nscDegreeDetails && credential.nscDegreeDetails.length) || 
    (credential.nscTransactionStatus && credential.nscTransactionStatus === constants.nscTransactionStatus.UCF);
  }

  getTooltipText(credential: any) {
    let strData = '';
    const degreeObj = credential.nscDegreeDetails;
    if (degreeObj.length) {
        degreeObj.forEach((deg: any) => {
            strData += '<b>Degree:</b> ' + deg.degreeTitle + ',<br/>' +
                (deg.officialSchoolName ? '<b>SchoolName:</b> ' + deg.officialSchoolName + ',<br/>' : '') +
                (credential.yearAwarded ? '<b>YearAwarded:</b> ' + credential.yearAwarded + ',<br/>' : '') +
                (credential.degreeAwardDateRange ? '<b>AwardDateRange:</b> ' + credential.degreeAwardDateRange + ',<br/>' : '') +
                '<span><b>Majors:</b> ';
            let majors = '';
            deg.majorCoursesOfStudy.forEach((major: any) => {
                majors += major.course.replace(' ', '-') + '<br/>';
            });
            strData += majors.trim() + '</span>';
        });
    }
    else if (credential.nscTransactionStatus &&
        credential.nscTransactionStatus === constants.nscTransactionStatus.UCF) {
        strData += '<b>Degree:</b> No degrees were found.<br/><span><b>Majors:</b> No majors found.<span>';
    }
    return strData;
  }

  showDeleteReviewerConfirmation($event:Event,reviewer:Reviewer) {
    const data = {
      heading: `Are you sure you want to archive ${reviewer.firstName} ${reviewer.lastName}`,
      from: 'deleteReviewer',
      textAreaHeading: 'Comment',
      isCommentOptional: true
    }
    $event.stopPropagation();
    this.ref = this.dialogService.open(DeleteUserConfirmation, {
        data: data,
        header: 'Confirmation',
        width: '30vw',
        contentStyle: { overflow: 'auto' },
        breakpoints: {
            '960px': '75vw',
            '640px': '90vw'
        },
        closable: true
    });

    this.ref.onClose.subscribe((data: DeleteUserByFirm) => {
        
        if (data) {
          const payload: DeleteUserByFirm = {
            reason : data.reason,
            comments: data.comments,
            firm : this.userObject.firm._id
          }
          this.userService.deleteUserByFirm(reviewer._id, payload).subscribe((response: any) => {
            this.closeDialog();
            this.toast.showSuccess('User archived successfully')
          })
        }
        
    });
  }

  // Checkbox selection methods
  onRowSelectionChange(credential: any, event: any): void {
    // PrimeNG checkbox returns event.checked instead of event.target.checked
    const isChecked = event.checked !== undefined ? event.checked : event.target?.checked;
    
    if (isChecked) {
      if (!this.selectedCredentials.find(c => c._id === credential._id)) {
        this.selectedCredentials.push(credential);
      }
    } else {
      this.selectedCredentials = this.selectedCredentials.filter(c => c._id !== credential._id);
    }
    this.updateSelectAllState();
  }

  onSelectAllChange(event: any): void {
    // PrimeNG checkbox returns event.checked instead of event.target.checked
    const isChecked = event.checked !== undefined ? event.checked : event.target?.checked;
    
    if (isChecked) {
      // Only select credentials that are not manually approved
      this.selectedCredentials = this.credentials.filter(credential => 
        credential.bgStatus !== constants.secureBackgroundStatus.manualApproved
      );
      this.selectAll = true;
    } else {
      this.selectedCredentials = [];
      this.selectAll = false;
    }
  }

  updateSelectAllState(): void {
    const eligibleCredentials = this.credentials.filter(credential => 
      credential.bgStatus !== constants.secureBackgroundStatus.manualApproved
    );
    this.selectAll = eligibleCredentials.length > 0 && this.selectedCredentials.length === eligibleCredentials.length;
  }

  isCredentialSelected(credential: any): boolean {
    return this.selectedCredentials.some(c => c._id === credential._id);
  }

  getSelectedCredentialsCount(): number {
    return this.selectedCredentials.length;
  }

  isCredentialEligibleForSelection(credential: any): boolean {
    return credential.bgStatus !== constants.secureBackgroundStatus.manualApproved && credential.bgStatus !== constants.secureBackgroundStatus.autoApproval;
  }

  getEligibleCredentialsCount(): number {
    return this.credentials.filter(credential => 
      credential.bgStatus !== constants.secureBackgroundStatus.manualApproved && credential.bgStatus !== constants.secureBackgroundStatus.autoApproval
    ).length;
  }
}
